module.exports = __webpack_public_path__ + "static/media/icon_biaozhun.919e5700.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/compliance/icon_biaozhun.svg
// module id = 506
// module chunks = 0